exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pricing-option-header{padding:15px 0 5px;background:#173031;border-bottom:1px solid #7e7e7e}.pricing-option-header .icon{color:#fff}.pricing-option-header__title{margin:10px 0 0;color:#fff;font-weight:400}.pricing-option-header__meta{color:#fff;font-size:1.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/pricingoptions/pricingoption/pricingoptionheader.styl
// module id = 508
// module chunks = 0